// The shell's entries, each owned by a feature, and what follows from the set an environment
// has on (ADR-0005). The set itself comes from /api/me; nothing here is built in.
//
// A third entry here is a third screen, a third Feature in trex/common/features.py, and a third
// variable in each deployment workflow - nothing else has to change.

export const ENTRIES = [
  // The hub is for BDs alone (ADR-0010), mirroring the `Commercial` gate in trex/auth/roles.py.
  // It is first so that it is home for a BD: they open T-REX on a phone to report, not to browse.
  { feature: 'commercial_hub', to: '/hub', label: 'Hub', roles: ['COMMERCIAL'] },
  { feature: 'deals', to: '/deals', label: 'Deals' },
  { feature: 'delivery_tracker', to: '/deliveries', label: 'Delivery tracker' },
  { feature: 'counterparties', to: '/counterparties', label: 'Counterparties' },
  // Economics is not for every reader (TX-US-0025): an entry naming roles shows only to a holder
  // of one of them. It mirrors ECONOMICS_ROLES in trex/auth/roles.py; the API is the authority.
  {
    feature: 'economics',
    to: '/economics',
    label: 'Economics',
    roles: ['OPERATIONS', 'RISK', 'FINANCE'],
  },
];

// Whether a caller holding `roles` may have the entry: every role may, unless it names some.
export const entryAllowed = (entry, roles = []) =>
  !entry.roles || entry.roles.some((role) => roles.includes(role));

// The entries to show, in the shell's order.
export const enabledEntries = (features, roles = []) =>
  ENTRIES.filter((entry) => features.includes(entry.feature) && entryAllowed(entry, roles));

// Where "/" and the mark go: the first enabled entry, or nowhere when nothing is on.
export const homeFor = (features, roles = []) => enabledEntries(features, roles)[0]?.to ?? null;

// The entry a path belongs to, or undefined for a path that belongs to none (the root).
export const entryOf = (pathname) =>
  ENTRIES.find((entry) => pathname === entry.to || pathname.startsWith(`${entry.to}/`));

// The feature a path belongs to, or undefined for a path that belongs to none.
export const featureOf = (pathname) => entryOf(pathname)?.feature;
